// 見積機能の公開時に、ホームとヘッダーの入口をまとめて有効にする（true にする）。
// メニュー表示だけを制御し、ルートやAPIのアクセス権限は変更しない。
export const SHOW_ESTIMATE_MENU = false;
